import React, { useContext } from 'react';
/*
import type { ICallToAction } from '@stereoagency/ui/src';
*/
import { DynamicSVGComponent } from '@stereoagency/ui';
// import parse from 'html-react-parser';
import flush from 'just-flush';
import type { ILazyBlocksImage } from '@/types';
import { LinesContext } from '@/components';
import { useCallToActions, useMediaItems } from '@/hooks';
import { parseHtml } from '@/utils';

export type Props = {
  data: {
    title?: string;
    label?: string;
    bubbles:{
      solution_code: string;
      icon: ILazyBlocksImage;
      title: string;
      description: string;
      callToAction?: number;
    }[]
  }
};


export default function NvisoDynamicSVGComponent({data : {title, label, bubbles} } : Props): JSX.Element {
  const { enableLines } = useContext(LinesContext);
  const mediaItemIds = Array.from(bubbles.reduce<Set<number>>((acc, bubble) => {
    if (typeof bubble.icon?.id === 'number') { acc.add(bubble.icon.id); }
    return acc;
  }, new Set()) ?? new Set<number>());
  const mediaItems = useMediaItems(mediaItemIds);

  const callToActionIds = Array.from(bubbles.reduce<Set<number>>((acc, bubble) => {
    if (typeof bubble.callToAction === 'number') { acc.add(bubble.callToAction); }
    return acc;
  }, new Set()) ?? new Set<number>());
  const callToActionObjects = useCallToActions(callToActionIds, true);

  const entries = flush(bubbles?.map((bubble) => {
    const icon = typeof bubble.icon?.id === 'number' ? mediaItems.get(bubble.icon.id) : null;
    const cta = typeof bubble.callToAction === 'number' ? callToActionObjects.get(bubble.callToAction) : null;
    if (!icon?.mediaItemUrl || !bubble.title) return null;
    return {
      solution_code: bubble.solution_code,
      icon: {
        src: icon.mediaItemUrl,
        width: icon.mediaDetails?.width ?? 140,
        height: icon.mediaDetails?.height ?? 140,
      },
      title: bubble.title,
      description: bubble.description ? parseHtml(bubble.description) : null,
      callToAction: cta ?? undefined, /* bubble.callToAction, */
    };
  }) ?? []);


  return (
    <DynamicSVGComponent
      bubblesIconDetailsGridCards={entries}
      enableLines={enableLines}
      title={title}
      label={label}
    />
  );
}